import React, { useState, useEffect } from 'react'
import { Helmet } from 'react-helmet-async'
import './MyOrderDetail.scss'
import AccountMenu from 'components/User/AccountMenu'
import MyOrderDetailInfo from 'components/User/MyOrderDetailInfo'
import MyOrderDetailListProduct from 'components/User/MyOrderDetailListProduct'
import { useParams, Link } from 'react-router-dom'
import { getOrderDetail } from 'api/Order'

interface OrderDetailData {
  id: number;
  customer_id: number;
  code: string;
  total: number;
  total_discount: number | null;
  actual_total?: number;
  actual_total_discount?: number;
  voucher_id?: number | null;
  fullname: string;
  phone: string;
  address: string;
  note?: string;
  created_at?: string;
  updated_at?: string;
  status?: number;
  payment?: number;
  payment_status?: number;
  history: {
    id: number;
    order_id: number;
    created_by: number;
    status: string;
    note: string;
    created_at: string;
    updated_at: string;
  }[];
  order_product: {
    id: number;
    order_id: number;
    discount_price: number | null;
    status: number | null;
    quantity_product: number;
    name_product: string;
    slug_product: string;
    avatar_product: string;
    price_product: number;
    product_id?: number;
    point_product?: number;
    actual_quantity?: number;
  }[];
  redeemed_gifts?: {
    id: number;
    order_id: number;
    gift_id: number;
    name: string;
    avatar: string;
    point: number;
    status: 'PENDING' | 'DONE' | 'CANCELLED' | string;
    product?: {
      avatar: string;
      id: number;
      name: string;
      slug: string;
    }
  }[];
  voucher?: {
    id: number;
    name: string;
    code: string;
    type: 'fixed' | 'percent' | 'ship' | 'gift';
    value: string | number;
    cap_amount?: string | number | null;
    global_quota?: number | null;
    start_date?: string | null;
    end_date?: string | null;
  } | null;
  pricing?: {
    original_items_amount: number;
    total_discount: number;
    final_items_amount: number;
    final_total_amount: number;
    actual_original_amount?: number;
    actual_total_discount?: number;
    actual_final_amount?: number;
    point_earned?: number;
    voucher_breakdown?: {
      code: string;
      template_name: string;
      discount_applied: number;
      applied_to: 'order' | 'shipping';
      type: 'fixed' | 'percent' | 'ship' | 'gift';
    }[];
  };
}

const WishlistPage: React.FC = () => {
  const { slug } = useParams<{ slug: string }>();
  const [orderDetail, setOrderDetail] = useState<OrderDetailData | null>(null);
  const [totalPoint, setTotalPoint] = useState(0);
  useEffect(() => {
    document.body.classList.add("NoneHeaderFooter");

    const fetchOrderDetail = async () => {
      if (slug) {
        const response = await getOrderDetail(slug);
        if (response && response.status) {
          setOrderDetail(response.data);
          const totalPoints = response.data.order_product.reduce((acc, product) => {
            const quantity = product.actual_quantity ?? product.quantity_product ?? 0;
            return acc + ((product.point_product || 0) * quantity);
          }, 0);
          setTotalPoint(totalPoints);
        }
      }
    };

    fetchOrderDetail();

    return () => {
      document.body.classList.remove("NoneHeaderFooter");
    };
  }, [slug]);

  if (!orderDetail) {
    return (
        <>
            <div className='style_container__3o3Ct my-order-detail-page'>
                Loading...
            </div>
        </>
    )
  }

  return (
    <>
      <Helmet>
        <title>Chi tiết đơn hàng - Dược Tâm Hạnh</title>
        <meta name="description" content="Xem chi tiết đơn hàng tại Dược Tâm Hạnh." />
      </Helmet>
      <div className='style_container__3o3Ct my-order-detail-page'>
        <div className="styles_wrapDirect__RrlO8 MuiBox-root css-0 hidden-1199">
          <nav className="MuiTypography-root MuiBreadcrumbs-root MuiTypography-body1 MuiTypography-colorTextSecondary" aria-label="breadcrumb">
            <ol className="MuiBreadcrumbs-ol">
              <li className="MuiBreadcrumbs-li">
                <a className="styles_item_breadcrumb__eYGFd" href="/">Trang chủ</a>
              </li>
              <li aria-hidden="true" className="MuiBreadcrumbs-separator" ins-init-condition="#Lk11aUJyZWFkY3J1bWJzLW9sIGxpOm5vdCg6Zmlyc3Qp">
                <svg className="MuiSvgIcon-root MuiSvgIcon-fontSizeSmall" focusable="false" viewBox="0 0 24 24" aria-hidden="true">
                  <path d="M10 6L8.59 7.41 13.17 12l-4.58 4.59L10 18l6-6z"></path>
                </svg>
              </li>
              <li className="MuiBreadcrumbs-li">
                <a className="styles_item_breadcrumb__eYGFd" href="/my-order">Danh sách đơn hàng</a>
              </li>
              <li aria-hidden="true" className="MuiBreadcrumbs-separator" ins-init-condition="#Lk11aUJyZWFkY3J1bWJzLW9sIGxpOm5vdCg6Zmlyc3Qp">
                <svg className="MuiSvgIcon-root MuiSvgIcon-fontSizeSmall" focusable="false" viewBox="0 0 24 24" aria-hidden="true">
                  <path d="M10 6L8.59 7.41 13.17 12l-4.58 4.59L10 18l6-6z"></path>
                </svg>
              </li>
              <li className="MuiBreadcrumbs-li" ins-init-condition="#Lk11aUJyZWFkY3J1bWJzLW9sIGxpOm5vdCg6Zmlyc3Qp">
                <span className="styles_item_breadcrumb__eYGFd styles_last_breadcrumb__c7IQm">Chi tiết đơn hàng #{orderDetail.code}</span>
              </li>
            </ol>
          </nav>
        </div>
        <div className="jss3">
          <AccountMenu />
          <div className="styles_full_width__2R9Yf">
            <div className="MuiGrid-root styles_comeback__YRafY MuiGrid-item MuiGrid-grid-xs-12"><Link to="/my-order">&lt;&lt; Quay lại đơn hàng của tôi</Link></div>
            <MyOrderDetailInfo orderDetail={orderDetail} />
            <MyOrderDetailListProduct
              products={orderDetail.order_product}
              redeemedGifts={orderDetail.redeemed_gifts}
              subtotal={orderDetail.total}
              pricing={orderDetail.pricing}
              discount={orderDetail.pricing?.actual_total_discount ?? orderDetail.pricing?.total_discount ?? orderDetail.actual_total_discount ?? (orderDetail.total_discount ?? 0)}
              total_point={totalPoint}
              actual_final_amount={orderDetail.pricing?.actual_final_amount}
              total={orderDetail.pricing?.final_total_amount ?? orderDetail.actual_total ?? orderDetail.total}
            />
            <div className="MuiGrid-root styles_comeback__YRafY MuiGrid-item MuiGrid-grid-xs-12" style={{ marginTop: "25px" }}><Link to="/my-order">&lt;&lt; Quay lại đơn hàng của tôi</Link></div>
          </div>
        </div>
      </div>
    </>
  )
}

export default WishlistPage
